import React, { useState, useMemo } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { useSelector } from "react-redux";
const MobileSidebar = () => {
  // const SidebarData = useSelector((state) => state.sidebar_data);
  // console.log(sidebarData, "sidebar");
 const translation = useSelector((state) => state.root.translation);
   const sidebarData = useMemo(() => SidebarData(translation), [translation]);
  const Location = useLocation();
  const safeJsonParse = (item, defaultValue) => {
    try {
      return JSON.parse(item) || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  };
  const permissions =   safeJsonParse(localStorage.getItem("permissions"), null);//useSelector(state => state.root.permissions) || [];
  const roleTitle =   localStorage.getItem("roleTitle");

  const roleTitleAdmin =   localStorage.getItem("roleTitleAdmin");//useSelector(state => state.root.roleTitleAdmin) || [];
  // Check if user has permission to view a specific module
  const hasPermission = (permissionKey) => {
    return roleTitle === roleTitleAdmin || (
      Array.isArray(permissions) && 
      permissions.some(p => 
        p.Module && p.Permission && 
        p.Module.toLowerCase() === permissionKey && 
        p.Permission.toLowerCase() === 'view'
      )
    );
    
  };
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    if (title == subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const filteredSidebarData = sidebarData.reduce((acc, mainLabel) => {
    const filteredSubmenuItemsByPermission = mainLabel.submenuItems.filter(item => hasPermission(item.key));
  console.log('filteredSubmenuItemsByPermission',filteredSubmenuItemsByPermission);
    // Exclude specific submenuItems if tenantType is "all"
    const filteredSubmenuItems =  filteredSubmenuItemsByPermission;
  
    // Only include mainLabel if it has any valid submenuItems
    if (filteredSubmenuItems.length > 0) {
      acc.push({ ...mainLabel, submenuItems: filteredSubmenuItems });
    }
    console.log('filteredSubmenuItems',filteredSubmenuItems);
    console.log('mainLabel?.submenuItems',mainLabel?.submenuItems);
  
    return acc;
  }, []);

  console.log('filteredSidebarData',filteredSidebarData);

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {filteredSidebarData?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>

                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        console.log('title',title);
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array?.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array?.push(item?.link);
                            });
                          }
                          return link_array;
                        });
                        title.links = link_array;
                        return (
                          <>
                            <li className="submenu" key={i}>
                              <Link
                                to={title?.link}
                                onClick={() => toggleSidebar(title?.label)}
                                className={`${
                                  subOpen == title?.label ? "subdrop" : ""
                                } ${
                                  title?.link?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                }
                            `}
                              >
                                {/* <Grid /> */}
                                {title?.icon}
                                <span>{title?.label}</span>
                                <span
                                  className={title?.submenu ? "menu-arrow" : ""}
                                />
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen == title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                      {/* {item.lebel} */}
                                      <Link
                                        to={item?.link}
                                        className={
                                          item?.submenuItems
                                            ?.map((link) => link?.link)
                                            .includes(Location.pathname) ||
                                          item?.link == Location.pathname
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() => {
                                          toggleSubsidebar(item?.label);
                                        }}
                                      >
                                        {item?.label}
                                        <span
                                          className={
                                            item?.submenu ? "menu-arrow" : ""
                                          }
                                        />
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar == item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, titleIndex) => (
                                            <li key={titleIndex}>
                                              {/* {item.lebel} */}
                                              <Link
                                                to={items?.link}
                                                className={`${
                                                  subsidebar == items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                  items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  items?.link ==
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default MobileSidebar;
